// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Button } from '@op/opds.opux';
import { useNavigate } from 'react-router';

interface RedirectButtonProps {
    onClick?: () => boolean | void;
    children: React.ReactNode;
    to: string;
    className?: string;
    id?: string;
    primary?: boolean;
    [key: string]: any; // For any additional props
}

const RedirectButton: React.FC<RedirectButtonProps> = ({ onClick, children, ...props }) => {
    const navigate = useNavigate();

    return (
        <Button
            {...props}
            onClick={() => (onClick == null || onClick()) && navigate(props.to)}
            data-testid="adminInfoRow"
        >
            {children}
        </Button>
    );
};

export default RedirectButton;
